import { createContext, useContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const StatusTagContext = /*#__PURE__*/createContext(undefined);
export const StatusTagProvider = ({
  tagStyleOverrides,
  children
}) => {
  return /*#__PURE__*/_jsx(StatusTagContext.Provider, {
    value: {
      tagStyleOverrides
    },
    children: children
  });
};

/**
 * Provides the context for the `StatusTag` component.
 * Note: The context is only available when the `StatusTag` component is rendered as an ancestor.
 * @returns StatusTagContext - The context for the `StatusTag` component.
 * @returns StatusTagContext.tagStyleOverrides - Style overrides to be applied to the `Tag` component.
 */
export const useStatusTagContext = () => {
  const statusTagContext = useContext(StatusTagContext);
  return statusTagContext;
};